// extracted by mini-css-extract-plugin
module.exports = {"loading":"MixOptionsSection_loading__SiitY"};